<div
  fxLayout="column"
  class="download-order"
  fxLayoutAlign="space-between center"
>
  <div
    class="header"
    fxFlex="100"
    fxLayout="row wrap"
    fxLayoutAlign="space-around center"
  >
    <div class="type">نوع: سفارش پایان‌نامه</div>
    <div
      class="orderCode"
      (click)="copyOrderHashToClipboard()"
      matRipple
      style="cursor: pointer"
      matTooltip="کپی"
    >
      شماره: {{ orderObject.hash }}
      <jam-icon name="clipboard"></jam-icon>
    </div>
    <div class="date">{{ toJalaliDate(orderObject.createdAt) }}</div>
  </div>

  <div class="body" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <div class="edited-download">
      <button
        color="primary"
        mat-raised-button
        *ngIf="orderObject.status === 'done'"
      >
        <span>دانلود فایل ویرایش شده</span>
        <jam-icon name="shield-check-f"></jam-icon>
      </button>

      <button
        color="accent"
        mat-raised-button
        *ngIf="orderObject.status === 'calculation'"
      >
        <span>در حال محاسبه قیمت </span>
        <jam-icon name="clock-f"></jam-icon>
      </button>
      <button
        color="accent"
        mat-raised-button
        *ngIf="orderObject.status === 'payment'"
      >
        <span>در انتظار پرداخت </span>
        <jam-icon name="paypal"></jam-icon>
      </button>

      <button
        color="warn"
        mat-raised-button
        *ngIf="orderObject.status === 'failed'"
      >
        <span>لغو شده </span>
        <jam-icon name="bookmark-remove-f"></jam-icon>
      </button>

      <button
        color="warn"
        mat-raised-button
        *ngIf="orderObject.status === 'progress'"
      >
        <span>لغو شده </span>
        <jam-icon name="bookmark-remove-f"></jam-icon>
      </button>
    </div>

    <div
      class="more-info"
      fxLayout="row wrap"
      fxLayoutAlign="space-between center"
    >
      <div class="uploaded-info">
        <button mat-stroked-button>فایل مقاله / پایان‌نامه</button>
      </div>
      <div class="desc-file">
        <button mat-stroked-button color="primary">
          فایل توضیحات و فرمت ارائه شده به دانشجو
        </button>
      </div>
      <div class="desc-file">
        <button mat-button color="primary">مشاهده توضیحات</button>
      </div>
    </div>
  </div>
</div>
